import tabs from './tabs';
import slider from './slider';
import accordion from './accordion';
import lightbox from './lightbox';
import pageAnim from './pageAnim';
import customFormInp from './customFormInp';
import activityDate from './activity-date';
import historyText from './history-text';
import phoneFormat from './phoneFormat';

export {
  tabs,
  slider,
  accordion,
  lightbox,
  pageAnim,
  customFormInp,
  activityDate,
  historyText,
  phoneFormat,
};
